import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DateFormatPipe,
  FilesizePipe,
  LabelStyleDirective,
  NoDataPipe,
} from '@web/shared/ui';
import { AdminMultimediaDetails } from '../../models/admin-multimedia-details';
import { isNotNil } from '@web/utils';
import { MultimediaAttributeKey } from '../../types/multimedia-attribute-key';

@Component({
  selector: 'app-multimedia-attributes',
  imports: [
    CommonModule,
    DateFormatPipe,
    FilesizePipe,
    LabelStyleDirective,
    NoDataPipe,
  ],
  templateUrl: './multimedia-attributes.component.html',
  styleUrl: './multimedia-attributes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultimediaAttributesComponent {
  /* prettier-ignore */
  public readonly attributesToShow = input<MultimediaAttributeKey[]>(['id', 'filenameWithExtension', 'mimeType', 'size', 'dimensions', 'createdAt']);
  public readonly multimedia = input.required<AdminMultimediaDetails>();

  public shouldShowDimensions(multimedia: AdminMultimediaDetails): boolean {
    return isNotNil(multimedia.dimensions);
  }

  public shouldShowAttribute(key: MultimediaAttributeKey): boolean {
    return this.attributesToShow().includes(key);
  }
}
